"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _StepIcon.default;
  }
});

var _StepIcon = _interopRequireDefault(require("./StepIcon"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/StepIcon/index.js
// module id = 199
// module chunks = 0